// extracted by mini-css-extract-plugin
export default {"number_digits_container":"number-digits_number_digits_container__9UNzg"};